export default "__VITE_ASSET__0d6d74dd__"